import { Note } from '@/types';

import { toNoteMutationInput } from './resourceMutationPayloads';
import { createSanitizedResourceService, QueryParams } from './resources';

const base = createSanitizedResourceService<
    Note,
    ReturnType<typeof toNoteMutationInput>,
    ReturnType<typeof toNoteMutationInput>
>('/api/notes', toNoteMutationInput, toNoteMutationInput);

export const noteService = {
    ...base,
    list: <TParams extends QueryParams = QueryParams>(params?: TParams) => base.list(params),
    setArchived: (id: string, archived: boolean) => base.update(id, { archived }),
    setFavorite: (id: string, favorited: boolean) => base.update(id, { favorited }),
    setLocked: (id: string, locked: boolean) => base.update(id, { locked }),
};
